module.exports = __webpack_public_path__ + "img/thumbnail_BlackWildebeest_j_albino.6147321e.png";